module.exports = __webpack_public_path__ + "static/media/jennifer.adbbd3ef.jpg";